import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Main from '../../pages/Main'

import './Grid.scss'

const Grid = () => {
  return (
    <>
      <Header/>
      <Main/>
      <Footer/>
    </>
  )
}

export default Grid